<script>
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Common from '../../../common/Common.vue'
import Services from '../../../common/Services.vue'
import { applySessionScope } from '../../../utils/scope'
export default {
    async init(payload) {
        payload.initTable()

        const [reportNames, role, isSuperAdminMaster] = await Promise.all([Services.getIntegrationReportNamesTypes(payload), Common.getSubtype(payload), Common.isSuperAdminMaster(payload)])

        payload.reportNames = reportNames

        payload.role = role
        payload.isSuperAdminMaster = isSuperAdminMaster

        if (role === 'SUPER_ADMIN_MASTER') {
            payload.accounts = await Services.getAccounts(payload)
            payload.clients = await Services.getClients(payload)
        } else if (role === 'ADMIN' || role === 'MANAGER') {
            payload.clients = await Services.getClients(payload)
            payload.filters.account = Common.getAccountId(payload)
        } else if (role === 'OPERATOR') {
            payload.filters.account = Common.getAccountId(payload)
            payload.filters.client = Common.getClientId(payload)
            payload.sites = await Services.getSites(payload)
        }

        if (!payload.isSuperAdminMaster) {
            payload.columns.splice(5, 1)
            const companyLegacy = await Common.getLegacyAccount(payload)

            payload.sqlLegacyBase = companyLegacy?.sqlLegacyBase
            payload.companyLegacyId = companyLegacy?.companyLegacyId

            if (companyLegacy?.companyLegacyId) {
                payload.sites = await Services.getExternalSites(payload, {
                    sqlLegacyBase: companyLegacy?.sqlLegacyBase,
                    companyLegacyId: companyLegacy?.companyLegacyId,
                })
            } else {
                Common.show(payload, 'top-right', 'error', payload.$t('str.contact.admin.to.assign.account'))
            }

            payload.filter()
        } else {
            payload.accounts = await Services.getAccounts(payload)
        }
    },
    methods: {
        filter: function () {
            if (!applySessionScope(this, this.filters)) return

            if (this.isLoading) return

            if (this.role === 'SUPER_ADMIN_MASTER' && !this.filters.account) {
                Common.show(this, 'top-right', 'warn', this.$t('str.charts.select.account.required'))
                return
            }

            this.isLoading = true
            this.items = []

            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.filters,
                `${Endpoints.reportSettings.filter}`,
                response => {
                    this.items = response.results
                    this.isLoading = false
                },
                () => {
                    this.isLoading = false
                },
            )
        },
        selectItem(params) {
            const data = params && params?.row ? JSON.parse(JSON.stringify(params.row)) : { ...this.reportConfigObj }

            delete data.vgt_id
            delete data.originalIndex
            delete data.password

            data.account = data?.account?._id || ''

            this.data = data

            this.$bvModal.show('createReportSettingsModal')
        },
        async initTable() {
            this.columns = [
                {
                    label: this.$t('str.table.report.column.report.name'),
                    field: 'reportName',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.report.column.period'),
                    field: 'period',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.report.column.next.dispatch.date'),
                    field: 'nextDispatchDate',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.report.column.emails'),
                    field: 'emails',
                    width: '30%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.report.column.email.language'),
                    field: 'emailLanguage',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.report.column.account'),
                    field: 'account.name',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.report.column.client'),
                    field: 'client.name',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.report.column.site'),
                    field: 'site.name',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.site.groups.column.creat.at'),
                    field: 'createDate',
                    width: '20%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
            ]

            this.paginationOptions = {
                enabled: true,
                mode: 'records',
                perPage: 10,
                position: 'bottom',
                perPageDropdown: [10, 20, 50, 100],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                jumpFirstOrLast: true,
                firstLabel: this.$t('str.table.pagination.first.page'),
                lastLabel: this.$t('str.table.pagination.last.page'),
                nextLabel: this.$t('str.table.pagination.next.page'),
                prevLabel: this.$t('str.table.pagination.prev.page'),
                rowsPerPageLabel: this.$t('str.table.pagination.rows.per.page.lavel'),
                ofLabel: this.$t('str.table.pagination.of.label.page'),
                pageLabel: this.$t('str.table.pagination.page'),
                allLabel: this.$t('str.table.pagination.all.label'),
            }
        },
        changeAccount: async function () {
            const account = this.filters.account

            this.sites = []
            this.filters.client = ''
            this.filters.site = ''

            this.filter()

            this.clients = await Services.getClientsByAccount(this, account)
        },
        changeClient: async function () {
            const client = this.filters.client

            if (client === '') {
                this.filters.site = ''
            }

            this.filter()

            this.sites = await Services.getSitesByClient(this, client)
        },
        changeSite: function () {
            this.filter()
        },
        async addDeptLocalColumn() {
            const deptLocalColumn = {
                label: this.$t('str.table.report.column.dept.local.name'),
                field: 'deptLocalName',
                width: '20%',
                thClass: 'text-nowrap',
                tdClass: 'text-nowrap',
                sortable: true,
                filterable: true,
            }

            const insertIndex = this.columns.length - 1 // penúltimo lugar
            this.columns.splice(insertIndex, 0, deptLocalColumn)
        },
        changeDeptLocal: async function () {
            this.filter()
        },
        changeReportName: async function () {
            if (this.filters.reportName === 'REPORT_ANALYSIS_PATROLS_INTEGRATION') {
                await this.addDeptLocalColumn()
            } else {
                this.columns.splice(6, 1)
                this.filters.deptLocalId = ''
            }

            this.filter()
        },
        formatDate: Common.formatDateAndTime,
    },
}
</script>
